module.exports = __webpack_public_path__ + "img/petalouda.a50b3931.png";